import { useEffect, useRef } from 'react';
import useHttp from './useHttp';

const useSiteStatus = () => {
  const { getSiteStatus } = useHttp();
  const getSiteStatusRef = useRef(getSiteStatus);

  useEffect(() => {
    getSiteStatusRef.current = getSiteStatus;
  }, [getSiteStatus]);

  useEffect(() => {
    getSiteStatusRef.current().catch((err) => {
      console.error('Failed to fetch site status:', err);
    });

    const intervalId = setInterval(() => {
      getSiteStatusRef.current().catch((err) => {
        console.error('Failed to fetch site status:', err);
      });
    }, 240000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);
};

export default useSiteStatus;

